import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, ScriptLoader, WindowRef } from '@spartacus/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RecaptchaConnector } from './connector/recaptcha.connector';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {

  private windowReference: any = this.winRef.nativeWindow;
  loaded = false;

  constructor(
    protected scriptLoader: ScriptLoader,
    protected recaptchaConnector: RecaptchaConnector,
    protected winRef: WindowRef,
    protected globalMessageService: GlobalMessageService,
  ) {
  }

  initRecaptcha(): void {
    this.injectGoogleRecaptchaScript();
  }

  injectGoogleRecaptchaScript(): void {
    if (this.scriptLoader) {
      this.scriptLoader.embedScript({
        src: environment?.recaptchaV3?.scriptSrc,
        params: {
          render: environment?.recaptchaV3?.siteKey,
          onload: environment?.recaptchaV3?.onloadCallbackName,
          trustedtypes: 'true',
        },
        attributes: { type: 'text/javascript' },
        callback: () => {
          this.loaded = true;
        },
        errorCallback: err => console.log(err),
      });
    }
  }

  async getToken(): Promise<any> {
    if (this.loaded) {
      return await (this.windowReference).grecaptcha.execute(environment?.recaptchaV3?.siteKey, { action: 'submit' });
    }

    return new Promise((resolve, reject) => {
      this.showGlobalMessage(
        'forms.recaptcha.notLoaded',
        GlobalMessageType.MSG_TYPE_ERROR,
      );
      reject();
    });
  }

  validateRecaptchaToken(token: string): Observable<any> {
    return this.recaptchaConnector.validateRecaptcha(token);
  }

  recaptchaError(message): void {
    this.showGlobalMessage(
      message ? message : 'forms.recaptcha.fail',
      GlobalMessageType.MSG_TYPE_ERROR,
    );
  }

  showGlobalMessage(messageKey: string, messageType: GlobalMessageType): void {
    this.globalMessageService.add({ key: messageKey }, messageType);
  }
}
